
export const api_url = `https://api.testreporter.io`;
export const site_name = `Test Reporter`;
export const strip_publishable_key = `pk_test_51Ia3pCJA02tZ8cDtd20RoCqghfczGO88ZknSa5nzabkWa5bNMgBSMbmWnRXkSCLcmOBdeT5dfPcJMDHKuX7VQuSB00miTmQuEt`;
